import React, { useContext, useEffect, useRef, useState } from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import moment from 'moment';
import {
    InputLabel,
    Grid,
    TableCell,
    TableRow,
    Paper,
    FormHelperText,
    Typography,
    CircularProgress,
    IconButton,
    Button,
    Hidden,
    Container
} from '@material-ui/core';
import Axle from './AddInspectionCheck/vehicleAxel';
import ConfirmationModal from '../../../Core/Controls/Dialog/ConfirmationModal';
import DialogComp from '../../../Core/Modal/dialogModal';
import { InspectionCheckProvider as StateProvider, InspectionCheCkContaxt } from './AddInspectionCheck/InspectionCheckProvide';
import { AddCheckTableHeader } from './AddInspectionCheck/InspectionHeaders';
import { InspectionCheckBody } from './AddInspectionCheck/InspectionBody';
import { AppStorage } from '../../../Core/Service/storage-service';
import EditVehicleDailyChecks from './editVehicleDailyCheck';
import { InspectionBreakTest } from './AddInspectionCheck/BreakTest';
import { InspectionBreakPerfomance } from './AddInspectionCheck/BreakPerformance';
import { InspectionRoadTest } from './AddInspectionCheck/RoadTest';
import { InSpectionSignOff } from './AddInspectionCheck/signOff';
import { EditSInspectionSignOFF } from './AddInspectionCheck/editSignOff';
import ClearIcon from '@material-ui/icons/Clear';
import DoneIcon from '@material-ui/icons/Done';
import ImageUpload from './InspectionImageUpload';
import ActionTakenModal from './EditInspectionCheck/actionTakenModal';
import { InspectionNotes } from './InspectionNotes';
import { DatePicker, SecondaryButton, TextBox } from '../../../Core/FormInput';
import { BackButton, FailButton, MButton, NAButton, PassAllbutton, PassButton, PrimaryButton, RButton } from '../../../Core/FormInput/AppButton';
import formatters from '../../../Core/Grid/inputFormatter';
import VehicleInspectionMileagePhoto from './VehicleInspectionMileagePhoto';
import FileUploaderButton from '../../../Core/FileUploader';
import { getGenerateVehicleInspectionReportPdf } from '../../../Core/Service/vehicleTabChecks';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import AppContext from '../../../App/AppContext';
import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf';

const StyledTableCell = withStyles((theme) => ({
    head: {
        fontSize: 12,
        padding: '6px 16px',
        color: '#f50057',
        fontWeight: 700,
        textTransform: 'uppercase',
        letterSpacing: '0.5px'
    },
    body: {
        fontSize: 12,
        padding: '6px 16px'
    }
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
    root: {
        '&:nth-of-type(odd)': {
            backgroundColor: '#f8fafc'
        }
    }
}))(TableRow);

const useStyles = makeStyles((theme) => ({
    root: {
        marginTop: 10
    },
    loader: {
        width: '100%',
        minHeight: 400,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    },
    modalContent: {
        padding: '12px 16px',
        backgroundColor: '#f8fafc',
        minHeight: '100%',
        overflowY: 'auto'
    },
    headerCard: {
        padding: '12px 16px',
        backgroundColor: '#ffffff',
        border: '1px solid #e2e8f0',
        borderRadius: 8,
        boxShadow: '0 1px 3px rgba(0,0,0,0.04)',
        marginBottom: 8
    },
    legendContainer: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        flexWrap: 'wrap',
        gap: 8,
        paddingBottom: 8,
        borderBottom: '1px solid #f1f5f9'
    },
    legendTitle: {
        fontSize: 11.5,
        fontWeight: 700,
        color: '#f50057',
        textTransform: 'uppercase',
        letterSpacing: '0.5px'
    },
    legendItems: {
        display: 'flex',
        alignItems: 'center',
        flexWrap: 'wrap',
        gap: 6
    },
    headerRightActions: {
        display: 'flex',
        alignItems: 'center',
        gap: 16,
        flexWrap: 'wrap'
    },
    legendChip: {
        display: 'inline-flex',
        alignItems: 'center',
        gap: 5,
        padding: '2px 8px',
        borderRadius: 4,
        color: '#ffffff',
        fontSize: 11,
        fontWeight: 600,
        boxShadow: '0 1px 2px rgba(0,0,0,0.1)'
    },
    fieldLabel: {
        fontSize: 11.5,
        fontWeight: 600,
        color: '#334155',
        marginBottom: 3,
        display: 'block',
        position: 'relative',
        transform: 'none'
    },
    inputField: {
        backgroundColor: '#ffffff',
        '& .MuiOutlinedInput-root': {
            height: 36,
            fontSize: 13
        },
        '& .MuiOutlinedInput-input': {
            padding: '8px 12px',
            fontSize: 13
        }
    },
    sectionCard: {
        backgroundColor: '#ffffff',
        border: '1px solid #e2e8f0',
        borderRadius: 8,
        boxShadow: '0 1px 3px rgba(0,0,0,0.04)',
        marginBottom: 12,
        overflow: 'hidden'
    },
    separatorCard: {
        backgroundColor: 'grey',
        border: '1px solid #757575',
        borderRadius: 8,
        padding: '10px 16px',
        marginBottom: 12,
        display: 'flex',
        alignItems: 'center',
        boxShadow: '0 1px 3px rgba(0,0,0,0.06)'
    },
    separatorText: {
        fontSize: 12.5,
        fontWeight: 700,
        color: '#ffffff',
        textTransform: 'uppercase',
        letterSpacing: '0.5px',
        margin: 0
    },
    sectionHeader: {
        backgroundColor: '#ffffff',
        padding: '8px 16px',
        borderBottom: '1px solid #e2e8f0',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between'
    },
    sectionTitleWrap: {
        display: 'flex',
        alignItems: 'center',
        gap: 8
    },
    sectionAccent: {
        width: 4,
        height: 14,
        backgroundColor: '#f50057',
        borderRadius: 2,
        display: 'inline-block'
    },
    sectionTitleText: {
        fontSize: 12.5,
        fontWeight: 700,
        color: '#f50057',
        textTransform: 'uppercase',
        letterSpacing: '0.5px',
        margin: 0
    },
    title: {
        color: '#f50057',
        fontSize: 12.5,
        fontWeight: 700,
        textTransform: 'uppercase',
        letterSpacing: '0.5px',
        margin: 0,
        marginTop: 4,
        marginBottom: 8
    },
    eventBadge: {
        backgroundColor: '#fef3c7',
        color: '#92400e',
        fontSize: 11,
        fontWeight: 700,
        padding: '2px 8px',
        borderRadius: 4,
        cursor: 'pointer',
        border: '1px solid #fde68a'
    },
    sectionBody: {
        width: '100%'
    },
    bottomBar: {
        position: 'sticky',
        bottom: 0,
        zIndex: 10,
        backgroundColor: '#ffffff',
        border: '1px solid #e2e8f0',
        borderRadius: 8,
        padding: '10px 16px',
        boxShadow: '0 -2px 10px rgba(0,0,0,0.05)',
        marginTop: 14
    },
    axelTitles: {
        textAlign: 'center',
        color: '#f50057',
        fontSize: 12.5,
        fontWeight: 700,
        textTransform: 'uppercase',
        letterSpacing: '0.5px',
        width: '100%'
    },
    headings: {
        color: '#f50057',
        fontSize: 12.5,
        fontWeight: 700,
        textTransform: 'uppercase',
        letterSpacing: '0.5px',
        margin: 0,
        marginBottom: 10
    },
    paper: {
        padding: theme.spacing(1.5),
        color: theme.palette.text.secondary,
        border: '1px solid rgba(0,0,0,0.1)',
        borderRadius: 8,
        backgroundColor: '#ffffff'
    }
}));

const CheckButtons = {
    D: FailButton,
    M: MButton,
    N: NAButton,
    S: PassButton,
    R: RButton
};

const ButtonColors = {
    D: { color: '#d32f2f', value: () => <ClearIcon style={{ fontSize: 16, color: 'white' }} /> },
    M: { color: '#f57f17', value: () => <span style={{ fontSize: 12, fontWeight: 700, color: 'white' }}>M</span> },
    N: { color: '#1976d2', value: () => <span style={{ fontSize: 11, fontWeight: 700, color: 'white' }}>N/A</span> },
    S: { color: '#388e3c', value: () => <DoneIcon style={{ fontSize: 16, color: 'white' }} /> },
    R: { color: '#d32f2f', value: () => <ClearIcon style={{ fontSize: 16, color: 'white' }} /> }
};

const VehicleDailyChecks = (props) => {
    const portalSettings = AppStorage.getPortalSetting() || {};

    const history = useHistory();
    const [pdfLoading, setPdfLoading] = useState(false);
    const { showToast } = useContext(AppContext);
    const {
        btnLoader,
        state,
        flags,
        widths,
        handleInput,
        signCanvas,
        clear,
        GetTechnicianSign,
        imageHandler,
        onImageChange,
        changeState,
        changeNotesState,
        changeResutNotesState,
        changeAllChildChecks,
        handleInputs,
        useDefaultSig,
        handleConfirmPopup,
        submitData,
        sumbitImage,
        setState,
        HandleColspan,
        handleInspection,
        handleInpectionRow,
        closeInspection,
        InHire_imageHandler,
        getPreviousTyreData,
        onImageChangeAPI,
        RemoveImage,
        sumbitImageApi,
        imgLoader,
        isModal,
        closeActionTakenhandle,
        localFileInputRef,
        apiFileInputRef,
        pullEditInpectionChecks,
        setFlags
    } = useContext(InspectionCheCkContaxt);

    const classes = useStyles();

    const handleSignOff = () => {
        if (!state.vehicleInspectionSignedOffSignature) {
            setState((st) => ({
                ...st,
                errors: {
                    ...st?.errors,
                    vehicleInspectionSignedOffSignature: 'Signature is required'
                }
            }));
            return;
        }
        submitData(6);
    };

    const GenerateVehicleInspectionReportPdf = async () => {
        try {
            setPdfLoading(true);
            let res = await getGenerateVehicleInspectionReportPdf(props.data.vehicleInspectionID, state.scheduleEventID);

            if (res.success) {
                showToast('Invoice PDF Generated Successfully');
                if (pullEditInpectionChecks) {
                    await pullEditInpectionChecks();
                }
            } else {
                showToast(res.message);
            }
        } catch (err) {
            showToast(err?.message || 'Failed to generate PDF');
        } finally {
            setPdfLoading(false);
        }
    };

    const GlobalCss = withStyles((theme) => ({
        '@global': {
            '.MuiDialogContent-root': {
                padding: '0px',
                backgroundColor: '#f8fafc',
                overflowY: 'auto !important'
            }
        }
    }))(() => null);

    const InspHeader = () => {
        const hasNoDocument = Number(flags?.fileCount || 0) === 0;

        return (
            <>
                {/* <Grid item xs={12}> */}
                <div className={classes.legendContainer}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 12, flexWrap: 'wrap' }}>
                        <Typography className={classes.legendTitle} component="div" style={{ display: 'inline-flex', alignItems: 'center' }}>
                            <span>
                                {props.data.eventName} - {props.data.RegNo}
                            </span>
                            &nbsp;&nbsp;
                            {state.vehicleInspectionStatusID === 6 && (
                                <FileUploaderButton
                                    docIDPassed={true}
                                    recordId={props.data.vehicleInspectionID}
                                    fileUploaderConfigName="VehicleInspection"
                                    fileCount={flags.fileCount || 0}
                                    gridRelaod={pullEditInpectionChecks}
                                />
                            )}
                        </Typography>

                        {hasNoDocument && (
                            <SecondaryButton
                                onClick={GenerateVehicleInspectionReportPdf}
                                isBtnLoader={pdfLoading}
                                disabled={pdfLoading}
                                forceEnabled={true}
                                icon={PictureAsPdfIcon}
                            >
                                Generate PDF
                            </SecondaryButton>
                        )}
                    </div>

                    <div className={classes.headerRightActions}>
                        <div className={classes.legendItems}>
                            {state.buttonList?.map((k) => {
                                const Icon = ButtonColors[k.inspectionSheetCheckOptionCode]?.value;
                                return (
                                    <div
                                        key={k.inspectionSheetCheckOptionCode}
                                        className={classes.legendChip}
                                        style={{ backgroundColor: ButtonColors[k.inspectionSheetCheckOptionCode]?.color }}
                                    >
                                        {Icon && <Icon />}
                                        <span>{k.inspectionSheetCheckOptionDescription}</span>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </div>
                {/* </Grid> */}
            </>
        );
    };

    return (
        <>
            <GlobalCss />
            <DialogComp onClose={props.onClose} title={<InspHeader />} maxWidth="xl" fullWidth fullScreen overflow="auto">
                <div className={classes.modalContent}>
                    {state.loader ? (
                        <div className={classes.loader}>
                            <CircularProgress color="secondary" />
                        </div>
                    ) : (
                        <Grid container spacing={2}>
                            {/* Top Header Information & Legend */}
                            <Grid item xs={12}>
                                <Paper className={classes.headerCard} elevation={0}>
                                    <Grid container spacing={2} alignItems="flex-start">
                                        <Grid item xs={12} sm={4} md={4} lg={4} style={{ display: 'flex', flexDirection: 'column' }}>
                                            <InputLabel shrink className={classes.fieldLabel} style={{ marginBottom: 4, width: '100%' }}>
                                                Date Of Check
                                            </InputLabel>
                                            <DatePicker
                                                placeholder="Date Of Check"
                                                name="date"
                                                margin="none"
                                                size="small"
                                                disabled={state.isDisabled || Boolean(state.vehicleInspectionInspectorSignature)}
                                                onChange={handleInput}
                                                value={state.date}
                                                InputProps={{
                                                    className: classes.inputField,
                                                    inputProps: {
                                                        min: moment().subtract(6, 'd').format('YYYY-MM-DD'),
                                                        max: moment().format('YYYY-MM-DD')
                                                    }
                                                }}
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={4} md={4} lg={4} style={{ display: 'flex', flexDirection: 'column' }}>
                                            <InputLabel shrink className={classes.fieldLabel} style={{ marginBottom: 4, width: '100%' }}>
                                                Check carried out by
                                            </InputLabel>
                                            <TextBox
                                                margin="none"
                                                size="small"
                                                disabled={state.isDisabled || Boolean(state.vehicleInspectionInspectorSignature)}
                                                placeholder="Check carried out by"
                                                name="vehicleDailyCheckCheckerName"
                                                value={state.vehicleDailyCheckCheckerName}
                                                onChange={handleInput}
                                                InputProps={{
                                                    className: classes.inputField
                                                }}
                                            />
                                        </Grid>
                                        {flags?.displayMileage && (
                                            <Grid
                                                item
                                                xs={12}
                                                sm={4}
                                                md={4}
                                                lg={4}
                                                className="mandatory-fields"
                                                style={{ display: 'flex', flexDirection: 'column' }}
                                            >
                                                <InputLabel shrink required className={classes.fieldLabel} style={{ marginBottom: -0.5, width: '100%' }}>
                                                    Odometer Reading (KM)
                                                </InputLabel>
                                                <div style={{ display: 'flex', alignItems: 'center', gap: 6, width: '100%' }}>
                                                    <TextBox
                                                        type="number"
                                                        margin="none"
                                                        size="small"
                                                        disabled={state.isDisabled || Boolean(state.vehicleInspectionInspectorSignature)}
                                                        placeholder="Odometer Reading (KM)"
                                                        name="vehicleDailyCheckMileage"
                                                        onChange={handleInput}
                                                        value={state.vehicleDailyCheckMileage}
                                                        autofocus
                                                        style={{ flex: 1, margin: 0 }}
                                                        InputProps={{
                                                            className: classes.inputField
                                                        }}
                                                    />
                                                    <VehicleInspectionMileagePhoto
                                                        state={state}
                                                        setState={setState}
                                                        disabled={state.isDisabled || Boolean(state.vehicleInspectionInspectorSignature)}
                                                    />
                                                </div>
                                                <FormHelperText error>
                                                    {state.errors?.vehicleDailyCheckMileage}
                                                    {state.errors?.vehicleDailyCheckMileage && state.errors?.vehicleInspectionMileagePhoto ? ' | ' : ''}
                                                    {state.errors?.vehicleInspectionMileagePhoto}
                                                </FormHelperText>
                                            </Grid>
                                        )}
                                    </Grid>
                                </Paper>
                            </Grid>

                            {/* Inspection Notes */}
                            {state.inpsectionNotes && state.inpsectionNotes.length > 0 && (
                                <Grid item xs={12}>
                                    <InspectionNotes list={state.inpsectionNotes} />
                                </Grid>
                            )}

                            {/* Checks Section List */}
                            {state.checksList && state.checksList.length > 0 ? (
                                <Grid item xs={12}>
                                    {state.checksList.map((m, i) => {
                                        const hasValidChecks =
                                            m.inspectionSheetChecksVM && m.inspectionSheetChecksVM.some((p) => Boolean(p.inspectionSheetCheckDescription));

                                        // If inspectionSheetSectionSeprator is true and no valid checks -> show as separator divider
                                        if (Boolean(m.inspectionSheetSectionSeprator) && !hasValidChecks) {
                                            return (
                                                <div key={m.inspectionSheetSectionID || i} className={classes.separatorCard}>
                                                    <Typography className={classes.separatorText}>{m.inspectionSheetSectionDescription}</Typography>
                                                </div>
                                            );
                                        }

                                        // If no valid check description and inspectionSheetSectionSeprator is false -> do not show this section
                                        if (!hasValidChecks && !m.inspectionSheetSectionSeprator) {
                                            return null;
                                        }

                                        return (
                                            <div key={m.inspectionSheetSectionID || i} className={classes.sectionCard}>
                                                <div className={classes.sectionHeader}>
                                                    <div className={classes.sectionTitleWrap}>
                                                        <span className={classes.sectionAccent} />
                                                        <Typography className={classes.sectionTitleText}>{m.inspectionSheetSectionDescription}</Typography>
                                                    </div>
                                                    {flags?.startEventLabel && (
                                                        <div className={classes.eventBadge} onClick={() => handleInpectionRow(flags.startVehicleInspectionID)}>
                                                            {flags.startEventLabel}
                                                        </div>
                                                    )}
                                                    {flags?.endEventLabel && <div className={classes.eventBadge}>{flags.endEventLabel}</div>}
                                                </div>
                                                <AddCheckTableHeader m={m} PassAllbutton={PassAllbutton} />
                                                <div className={classes.sectionBody}>
                                                    {m.inspectionSheetChecksVM
                                                        ?.filter((p) => Boolean(p.inspectionSheetCheckDescription))
                                                        .map((p, idx) => (
                                                            <InspectionCheckBody
                                                                key={p.inspectionSheetCheckID || idx}
                                                                p={p}
                                                                m={m}
                                                                index={idx}
                                                                CheckButtons={CheckButtons}
                                                            />
                                                        ))}
                                                </div>
                                            </div>
                                        );
                                    })}
                                </Grid>
                            ) : null}

                            {/* Additional Check Sections */}
                            {flags?.displayTyres && (
                                <Grid item xs={12}>
                                    <div className={classes.sectionCard} style={{ marginBottom: 14 }}>
                                        <div className={classes.sectionHeader}>
                                            <div className={classes.sectionTitleWrap}>
                                                <span className={classes.sectionAccent} />
                                                <h3 className={classes.sectionTitleText}>Tyres Checks</h3>
                                            </div>
                                            {/* <PrimaryButton
                                                size="small"
                                                onClick={getPreviousTyreData}
                                                style={{ textTransform: 'capitalize', fontSize: 11.5, padding: '3px 12px' }}
                                            >
                                                Use last saved data
                                            </PrimaryButton> */}
                                        </div>
                                        <div style={{ padding: '12px 16px', overflowX: 'auto' }}>
                                            <Axle
                                                state={state}
                                                handleInputs={handleInputs}
                                                classes={classes}
                                                handleInput={handleInput}
                                                vehicleNoOfAxles={state.vehicleNoOfAxles}
                                                handleInspection={handleInspection}
                                            />
                                        </div>
                                    </div>
                                </Grid>
                            )}

                            {flags?.displayBrakeTest && (
                                <Grid item xs={12}>
                                    <InspectionBreakTest state={state} classes={classes} handleInput={handleInput} setState={setState} />
                                </Grid>
                            )}
                            {flags?.displayBrakePerformance && (
                                <InspectionBreakPerfomance Paper={Paper} classes={classes} state={state} handleInput={handleInput} />
                            )}
                            {flags?.displayRoadTest && <InspectionRoadTest Paper={Paper} classes={classes} handleInputs={handleInputs} state={state} />}

                            {/* Inspector Sign Off */}
                            <Grid item xs={12}>
                                <InSpectionSignOff
                                    classes={classes}
                                    handleInput={handleInput}
                                    state={state}
                                    useDefaultSig={useDefaultSig}
                                    clear={clear}
                                    GetTechnicianSign={GetTechnicianSign}
                                    signCanvas={signCanvas}
                                    portalSettings={portalSettings}
                                    flags={flags}
                                />
                            </Grid>

                            {/* Manager / Customer Sign Off */}
                            {flags.scheduleEventIs2ndSignOffRequired && Boolean(state.vehicleInspectionInspectorSignature) && (
                                <Grid item xs={12}>
                                    <EditSInspectionSignOFF
                                        classes={classes}
                                        handleInput={handleInput}
                                        state={state}
                                        setState={setState}
                                        portalSettings={portalSettings}
                                        flags={flags}
                                    />
                                </Grid>
                            )}

                            {/* Bottom Actions Bar */}
                            <Grid item xs={12}>
                                <Grid container spacing={2}>
                                    <Grid item xs={12} sm={4}>
                                        <SecondaryButton
                                            onClick={() => submitData(2)}
                                            isBtnLoader={btnLoader}
                                            disabled={btnLoader || Boolean(state.vehicleInspectionInspectorSignature)}
                                            fullWidth
                                            style={{ textTransform: 'uppercase', fontWeight: 600, fontSize: 12 }}
                                        >
                                            Save
                                        </SecondaryButton>
                                    </Grid>
                                    {flags.scheduleEventIs2ndSignOffRequired && Boolean(state.vehicleInspectionInspectorSignature) ? (
                                        <Grid item xs={12} sm={4}>
                                            <PrimaryButton
                                                onClick={handleSignOff}
                                                // onClick={handleConfirmPopup}
                                                isBtnLoader={btnLoader}
                                                disabled={state.isSignOff || btnLoader || state.vehicleInspectionStatusID === 6}
                                                fullWidth
                                                style={{ textTransform: 'uppercase', fontWeight: 600, fontSize: 12 }}
                                            >
                                                Sign off
                                            </PrimaryButton>
                                        </Grid>
                                    ) : (
                                        <Grid item xs={12} sm={4}>
                                            <PrimaryButton
                                                onClick={handleConfirmPopup}
                                                isBtnLoader={btnLoader}
                                                disabled={state.isSignOff || btnLoader || state.vehicleInspectionStatusID === 6}
                                                fullWidth
                                                style={{ textTransform: 'uppercase', fontWeight: 600, fontSize: 12 }}
                                            >
                                                Submit
                                            </PrimaryButton>
                                        </Grid>
                                    )}
                                    <Grid item xs={12} sm={4}>
                                        <SecondaryButton
                                            onClick={() => props.onClose()}
                                            fullWidth
                                            style={{ textTransform: 'uppercase', fontWeight: 600, fontSize: 12 }}
                                        >
                                            Cancel
                                        </SecondaryButton>
                                    </Grid>
                                </Grid>
                            </Grid>

                            <Grid item xs={12}>
                                <div style={{ height: 150 }} />
                            </Grid>
                        </Grid>
                    )}

                    {/* Modals */}
                    <ImageUpload
                        disabled={state.isModalReadonly}
                        state={state}
                        onImageChange={onImageChange}
                        submitImage={sumbitImage}
                        onClose={() => setState((st) => ({ ...st, showImageModal: false }))}
                        maxNumber={10}
                        isAPI={false}
                        loader={imgLoader}
                        showDialog={!!state.showImageModal}
                        fileInputRef={localFileInputRef}
                    />

                    <ImageUpload
                        disabled={state.isModalReadonly}
                        state={state}
                        isAPI={true}
                        onImageChange={onImageChangeAPI}
                        RemoveImage={RemoveImage}
                        submitImage={sumbitImageApi}
                        onClose={() => setState((st) => ({ ...st, showImageModalAPI: false }))}
                        maxNumber={10}
                        loader={imgLoader}
                        showDialog={!!state.showImageModalAPI}
                        fileInputRef={apiFileInputRef}
                    />

                    {state.showConfirmMessage ? (
                        <DialogComp title={'Confirm Vehicle Inspector Sign-Off'} onClose={handleConfirmPopup} maxWidth="sm">
                            <ConfirmationModal
                                message={
                                    'Please note that you will not be able to make any changes once submitted. Click the Confirm button to proceed or Cancel to abort.'
                                }
                                handleCancel={handleConfirmPopup}
                                handleSubmit={() => submitData(null)}
                                title={'Confirm Vehicle Inspector Sign-Off'}
                                isBtnLoader={btnLoader}
                                label="Confirm"
                            />
                        </DialogComp>
                    ) : null}

                    {state.openDefectInspection ? (
                        <EditVehicleDailyChecks
                            checkID={state.selectedRowInspectionID}
                            displayCheck={props.displayCheck}
                            onClose={closeInspection}
                            frompage={false}
                        />
                    ) : null}

                    {isModal?.actionTaken ? (
                        <DialogComp title="Defect Action" onClose={() => closeActionTakenhandle(false)} maxWidth="md" overflow="auto" fullWidth>
                            <ActionTakenModal fromReturnToEnginner={true} selectedCheck={isModal.selectedCheck} onClose={closeActionTakenhandle} />
                        </DialogComp>
                    ) : null}
                </div>
            </DialogComp>
        </>
    );
};

const Screen = (props) => {
    return (
        <StateProvider {...props}>
            <VehicleDailyChecks {...props} />
        </StateProvider>
    );
};
export default Screen;
